<template>
  <b-modal
    id="modalAlert"
    ref="modalAlert"
    size="md"
    modal-class="main-modal main-block"
    ok-title="Закрыть"
    ok-only
    ok-variant="success modal-ok"
    header-class="text-white border-0"
    header-close-variant="orange"
    :title="reason"
    title-class="text-center underlined-muted-title"
    footer-class="border-0"
    hide-footer
    body-class="pt-0"
    centered
  >
    <div class="row mx-0 col-12 mx-auto">
      <div class="col-12 mx-auto py-3 px-0">
        <div class="col-12 px-0">
          <div
            v-if="alertMessage"
            :class="'alert alert-'+alertType" role="alert"
            v-html="alertMessage"
          />
          <div v-else-if="isLoading">
            <div class="alert alert-primary">
              <div class="col-12 resp-loader loading">
                <i class="fa fa-spinner fa-spin fa-fw" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalAlert',
  data () {
    return {
      reason: '',
      message: null
    }
  },
  computed: {
    alertType () {
      return this.message.status === 'ok' ? 'success' : 'danger'
    },
    alertMessage () {
      if (this.message) {
        if (Array.isArray(this.message.msg)) {
          let msg = ''
          for (let i = 0; i < this.message.msg.length; i++) {
            msg += this.message.msg[i]
            msg += '<br>'
          }
          return msg
        }
        return this.message.msg
      }
      return null
    },
    isLoading () {
      if (!this.message) {
        return false
      }
      return this.message.status === 'loading'
    }
  },
  created () {
    const _this = this
    this.$root.$on('modalAlertMessage', function (value) {
      _this.message = value
      if (value.status === 'ok') {
        _this.reason = 'Сообщения'
      } else {
        _this.reason = 'Произошла ошибка'
      }
    })
  },
  mounted () {
    const _this = this
    this.$root.$on('modalAlertMessage', function (value) {
      _this.message = value
      if (value.status === 'ok') {
        _this.reason = 'Сообщения'
      } else {
        _this.reason = 'Произошла ошибка'
      }
    })
  }
}
</script>

<style>

</style>
